import { Button, Modal } from 'antd';
import React, { memo } from 'react';
import styled from 'styled-components';
import translations from 'translations';
import utilMessages from 'utils/messages';
import media from 'utils/mediaStyle';
import WarningRemoveAllCartIcon from '../icons/WarningRemoveAllCartIcon';
import useResize from 'hooks/useResize';

const AModal = styled(Modal)`
  .ant-modal-title {
    text-align: center !important;
    font-size: 20px !important;
    font-weight: 500 !important;
    line-height: 26px !important;
    color: #2f382c !important;
  }
  .ant-modal-close {
    top: 16px !important;
  }
  .ant-modal-close-x {
    font-size: 18px !important;
  }
  .ant-modal-content {
    width: 100% !important;
    max-width: 400px !important;
    padding: 20px !important;
  }
  .ant-modal-body {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #343538;
  margin-top: 8px;
  max-width: 248px;
  text-align: center;

  ${media.md`
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
  `}
`;

const ButtonActionsContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 8px;

  ${media.md`
        margin-top: 40px;
        gap: 12px;
    `}
`;
const CancelButton = styled(Button)`
  width: 100% !important;
  height: 44px;
  font-weight: 500 !important;
  font-size: 16px !important;
  box-shadow: none !important;
  color: #2f382c !important;
`;

const ConfirmButton = styled(Button)`
  width: 100% !important;
  height: 44px;
  font-weight: 500 !important;
  font-size: 16px !important;
  box-shadow: none !important;
  color: #e2483c !important;
`;

interface DeleteAllCartConfirmModalProps {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  onDeleteAllCart: () => void;
}
const DeleteAllCartConfirmModal = (props: DeleteAllCartConfirmModalProps) => {
  const { openModal, setOpenModal, onDeleteAllCart } = props;

  const { isMobile } = useResize();

  return (
    <>
      <AModal
        destroyOnHidden={false}
        title={' '}
        closable={true}
        open={openModal}
        footer={null}
        onCancel={() => {
          setOpenModal(false);
        }}
        centered
      >
        <WarningRemoveAllCartIcon width={isMobile ? 48 : 64} height={isMobile ? 48 : 64} />
        <Title>{translations(utilMessages.deleteAllCartConfirmMessage)}</Title>
        <ButtonActionsContainer>
          <CancelButton
            type="default"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            {translations(utilMessages.no)}
          </CancelButton>
          <ConfirmButton
            type="default"
            onClick={() => {
              onDeleteAllCart();
              setOpenModal(false);
            }}
          >
            {translations(utilMessages.removeAll)}
          </ConfirmButton>
        </ButtonActionsContainer>
      </AModal>
    </>
  );
};

export default memo(DeleteAllCartConfirmModal);
